// @flow strict
import styled from "styled-components";

const Content = styled.p`
  clear: both;
`;

export default Content;
